import React, { Component } from "react";
import "./style.css";
const Returns: React.FC = () => {
  //   const handleOnChangeText = (name, evt) => {
  //     if (name === "query") {
  //       this.setState({ query: evt.target.value });
  //     }
  //   };

  //   const handleOnSearch = () => {
  //     let query = this.state.query;
  //     query = query.trim();
  //     if (query && query.length) {
  //       history.push("/search?query=" + encodeURIComponent(query));
  //     }
  //   };

  return (
    <div className="container">
      <div className="w3-col m12">
        <h1>RETURN POLICY</h1>
        <p className="para">Last updated January 10, 2025</p>

        <h3>REFUNDS</h3>
        <p className="para">
          All sales are final and no refund will be issued.
        </p>

        <h3>QUESTIONS</h3>
        <p className="para">
          QUESTIONS If you have any questions concerning our return policy,
          please contact us at:
          <br />
          <a href="mailto:support@catalogix.ai">support@catalogix.ai</a>
        </p>
      </div>
    </div>
  );
};

export default Returns;
